/*
Use:
File:
{{ 'custom-dropdown-menu.css' | asset_url | stylesheet_tag }}
<script defer src="{{ 'custom-dropdown-menu.js' | asset_url }}"></script>

Structure:
<div class="dropdown-container">
	<button class="dropdown-toggle">DropDown Menu</button>

	<div class="dropdown-menu">
		<div class="dropdown-menu__content-wrapper">
			<div class="dropdown-menu__content">
					<button class="dropdown-menu__item">item-1</button>
					<button class="dropdown-menu__item">item-2</button>
					<button class="dropdown-menu__item">item-3</button>
			</div>
		</div>
	</div>
</div>
*/

class CustomDropdownMenu {
  constructor(
    {
      selectorContainer = "dropdown-container",
      selectorDropdownToggle = "dropdown-toggle",
      selectorDropdownMenu = "dropdown-menu",
      selectorDropdownMenuItem = "dropdown-menu__item",
      activeClassContainer = "dropdown-open",
      activeClassDropdownMenu = "dropdown-active",
      activeClassDropdownMenuItem = "dropdown-menu__item--active",
    } = {}
  ) {
    try {
      this.selectors = {
        container: selectorContainer,
        dropdownToggle: selectorDropdownToggle,
        dropdownMenu: selectorDropdownMenu,
        dropdownMenuItem: selectorDropdownMenuItem,
        activeClassContainer: activeClassContainer,
        activeClassDropdownMenu: activeClassDropdownMenu,
        activeClassDropdownMenuItem: activeClassDropdownMenuItem,
      }
      this.dropdownContainerList = document.querySelectorAll(`.${selectorContainer}`);

      this.render();
    } catch (e) {
    }
  }

  openDropDownMenu(parentContainer) {
    const dropdownMenu = parentContainer.querySelector(`.${this.selectors.dropdownMenu}`);

    parentContainer.classList.add("dropdown-open");
    dropdownMenu.classList.add(`${this.selectors.activeClassDropdownMenu}`)
  }

  closeDropDownMenu(parentContainer) {
    const dropdownMenu = parentContainer.querySelector(`.${this.selectors.dropdownMenu}`);

    parentContainer.classList.remove(`${this.selectors.activeClassContainer}`);
    dropdownMenu.classList.remove(`${this.selectors.activeClassDropdownMenu}`)
  }

  activeDropdownMenuItem(item) {
    const dropdownContainer = item.closest(`.${this.selectors.container}`);
    const dropdownToggle = dropdownContainer?.querySelector(`.${this.selectors.dropdownToggle}`);
    const dropdownMenuItems = dropdownContainer?.querySelectorAll(`.${this.selectors.dropdownMenuItem}`);

    dropdownMenuItems.forEach(elem => elem.classList.remove(`${this.selectors.activeClassDropdownMenuItem}`));
    item.classList.add(`${this.selectors.activeClassDropdownMenuItem}`);

    const activeMenuItem = dropdownContainer?.querySelector(`.${this.selectors.activeClassDropdownMenuItem}`);
    dropdownToggle.textContent = activeMenuItem.textContent;
  }

  render() {
    this.dropdownContainerList.forEach(container => {
      const menuItems = container.querySelectorAll(`.${this.selectors.dropdownMenuItem}`);
      const activeMenuItem = [...menuItems].find(item => item.classList.contains(`${this.selectors.activeClassDropdownMenuItem}`));

      if (activeMenuItem) {
        this.activeDropdownMenuItem(activeMenuItem)
      } else {
        this.activeDropdownMenuItem(menuItems[0]);
      }

      container.addEventListener("click", (event) => {
        const target = event.target;
        const isOpenDropdown = !!target.closest(`.${this.selectors.activeClassContainer}`);

        if (target.closest(`.${this.selectors.dropdownMenuItem}`)) {
          const menuItem = target.closest(`.${this.selectors.dropdownMenuItem}`);

          this.activeDropdownMenuItem(menuItem)
          this.closeDropDownMenu(container);
        }

        if (isOpenDropdown) {
          this.closeDropDownMenu(container);
        } else {
          this.openDropDownMenu(container);
        }
      })

      container.addEventListener("mouseleave", () => {
        this.closeDropDownMenu(container)
      })
    })
  }
}


new CustomDropdownMenu({
	selectorDropdownMenuItem: "our-product__trigger-tabs-item",
	activeClassDropdownMenuItem: "our-product__trigger-tabs-item--active"
})

new CustomDropdownMenu({
  selectorDropdownMenuItem: "blog-tags--list li a",
  activeClassDropdownMenuItem: "active"
})
